import React, { ChangeEvent, useEffect, useState } from "react";

import Typography from "@mui/material/Typography";
import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Paper,
  Switch,
  Tab,
  TextField,
} from "@mui/material";
import { TabContext, TabList } from "@mui/lab";
import AutoCompleteMultiSelect from "../../components/AutoCompleteMultiselect/AutoCompleteMultiSelect.tsx";
import TextAreaComponents from "../../components/TextAreaComponents/TextAreaComponents.tsx";
import galleryIcon from "./../../../assets/icons/gallery.png";
import plusIcon from "./../../../assets/icons/plus.png";
import "./AddItem.css";
import { Delete } from "@mui/icons-material";
import CancelIcon from "@mui/icons-material/Cancel";
import StickyHeadTable from "../../components/SpecificationTable/Specification.tsx";
import Details from "./../../product/components/Details.tsx";
import Story from "./../../product/components/Story.tsx";
import Instructions from "./../../product/components/Instructions.tsx";
import Cancel from "./../../../assets/icons/close.png";
import DetailsTable from "../../components/SpecificationTable/DetailsTable.tsx";
import SectionTable from "./SectionTable.tsx";
import ChickenIcon from "./../../../assets/icons/turkey.png";
import ChickenLegIcon from "./../../../assets/icons/chicken-leg.png";
import Burger1Icon from "./../../../assets/icons/burger1.png";
import Burger2Icon from "./../../../assets/icons/burger.png";
import itemImg from "./../../../assets/icons/sections.png";
import FullPizzaIcon from "./../../../assets/icons/pizza.png";
import pizzaIcon from "./../../../assets/icons/pizza (1).png";
import { getMinimalContentHeight } from "@mui/x-data-grid/hooks/features/rows/gridRowsUtils.js";
import SectionTableSubSection from "./SectionTableSubSection.tsx";
import CustomDialog from "../../components/CustomDialog/CustomDialog.tsx";
import importImg from "./../../../assets/icons/import.png";
import SectionImport from "./SectionImport/SectionImport.tsx";
import axios from "axios";
import SweetAlertModal from "../../components/SweetAlertModal/SweetAlertModal.js";
import jwtDecode from "jwt-decode";
import MenuKitchen from "./MenuKitchen/MenuKitchen.tsx";
import { ToastContainer, toast } from "react-toastify";
import { uploadOneFiles } from "../../../fileUploader/SingleFileUploader.js";
import SchedulerComponent from "../components/SchedulerView/ScheduleItemDialog/SchedulerComponent/SchedulerComponent.tsx";
import MenuSchedulerSelectDialog from "../components/AddSection/SectionSchedulerSelectDialog.tsx";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Tooltip } from "@mui/material";
import LoadingView from "../../components/LoadingView/LoadingView.js";
function AddSectionDialog(props) {
  const [imageMap, setimageMap] = useState([]);

  console.log("debug-props: ", props);

  const apiAddress = process.env.REACT_APP_SECRET;

  const [SectionMap, setsectionMap] = useState([]);
  const [MainsectionErr, setMainsectionErr] = useState(false);

  const [restaurantId, setRestaurantId] = useState();
  const restaurant = localStorage.getItem("restaurant");
  const [loadingModal, SetloadingModal] = React.useState(false);
  var res = JSON.parse(restaurant);
  const [
    openSectionCloseConfirmaitonModal,
    setopenSectionCloseConfirmaitonModal,
  ] = useState(false);

  console.log(props.lastRank);
  const [restaurantDatas, setRestaurantDatas] = React.useState([]);
  const from = props.from ? props.from : "";

  const token = localStorage.getItem("gotasteadmintoken");
  const [userId, setUserId] = useState();
  //const Restauranttoken = JSON.parse(localStorage.getItem("parentrestaurant"));
  const Restauranttoken = JSON.parse(localStorage.getItem("parentrestaurant"));

  const RestaurantLocaltoken = JSON.parse(localStorage.getItem("restaurant"));

  useEffect(() => {
    var PreFetchedRestaurant = restaurantDatas.find(
      (x) => x.id == RestaurantLocaltoken.id,
    );
    console.log("PreFetchedRestaurant", PreFetchedRestaurant);
    if (PreFetchedRestaurant) {
      let resList = [];
      let resList1 = [];
      resList.push(PreFetchedRestaurant);

      resList.map((dt, i) => {
        resList1.push(dt.id);
      });
      setSelectedRestaurantDatas(resList);
      setRestaurantArray(resList1);
    }
  }, [restaurantDatas]);

  const loadRestaurantName = () => {
    const restaurantObj = Restauranttoken;
    console.log(restaurantObj);
    var decodedData = {};
    if (token != null) {
      try {
        decodedData = jwtDecode(token);

        setUserId(decodedData.UserId);

        // setTokenData(decodedData)
      } catch (error) {}
    }

    axios
      // .get(apiAddress + "/api/api/RestaurantUserMapper/getbyuseridaAndRestaurantId?userId=" + decodedData.UserId+"&restaurantId="+Restauranttoken.id)
      // .get(
      //   apiAddress +
      //     `/api/Restaurant/getrestaurantdetailsbyrestaurantparentidanduserid/${decodedData.UserId}/${restaurantObj.id}`
      //     //`/api/RestaurantUserMapper/getbyuseridaAndRestaurantId?userId=${decodedData.UserId}&restaurantId=${Restauranttoken.id}`
      // )
      .get(
        apiAddress +
          `/api/RestaurantUserMapper/getbyuseridaAndRestaurantId?userId=${decodedData.UserId}&restaurantId=${Restauranttoken.id}`,
      )
      .then((response) => {
        var list = [];
        response.data.map((dt, i) => {
          var obj = {
            id: dt.restaurantId,
            title: dt.restaurantName,
          };
          list.push(obj);
        });
        setRestaurantDatas(list);
      });
  };
  const [restaurantAdded, setRestaurantAdded] = useState([
    { id: Restauranttoken.id, title: Restauranttoken.name },
  ]);
  const restaurantAddedvalue = (props) => {
    setRestaurantAdded(props);
    // setRestaurantErr(false);
    // loadKeyword(props);
    // loadMenuData(props);
  };

  useEffect(() => {
    loadRestaurantName();
    axios.get(apiAddress + "/api/Icon/getallicon").then((response) => {
      console.log(response.data);
      var list = [];
      response.data.map((dt, i) => {
        var obj = { code: dt.id, icon: dt.url, label: dt.name };
        list.push(obj);
      });
      setimageMap(list);
    });
    if (props.dialogType == "Add Sub Section") {
      console.log(props.dialogType);
      axios
        .get(
          apiAddress +
            "/api/Section/getallsectionbyrestaurantid?restaurantId=" +
            res.id,
        )
        .then((response) => {
          console.log(response.data);
          var list = [];
          response.data.map((dt, i) => {
            var obj = { code: dt.id, label: dt.keywordName, icon: dt.iconUrl };
            list.push(obj);
          });
          setsectionMap(list);
          // var list = [];
          // list.push(response.data)
        });
    }
    // loadMenuData();
  }, []);

  //test start
  const [selectedValue, setSelectedValue] = useState(null);
  const [selectedSectionValue, setSelectedSectionValue] = useState(null);
  const [selectedData, setSelectedData] = useState({});
  const [keyword, setKeyword] = useState(null);
  const handleAutocompleteChange = (event: ChangeEvent<{}>, value: any) => {
    setSelectedValue(value);
    setselectedValuealid(false);
    //setImageDisable(true)
  };
  const handleAutocompleteSectionChange = (
    event: ChangeEvent<{}>,
    value: any,
  ) => {
    setSelectedSectionValue(value);
    console.log(value);
    setSectionValid(false);
  };
  console.log(selectedSectionValue);
  const handleKeyword = (event) => {
    setKeywordValid(false);
    setKeyword(event.target.value);
  };

  const [SectionValid, setSectionValid] = useState(false);

  const [keywordValid, setKeywordValid] = useState(false);
  const [selectedValueValid, setselectedValuealid] = useState(false);
  const [sectionAddedValid, setsectionAddedValid] = useState(false);
  const onClickSave = async () => {
    var valid = true;

    if (keyword == undefined || keyword == "") {
      valid = false;
      setKeywordValid(true);
    }
    if (sectionAdded == undefined || sectionAdded.length == 0) {
      valid = false;
      setsectionAddedValid(true);
    }
    if (restaurantArray.length == 0) {
      toast.error("Restaurant field is empty", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    if (menuIds.length == 0) {
      toast.error("Menu field is empty", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
    var logoUrl = [];
    var ImageType = "";
    if (state.selectedImages.length >= 1) {
      logoUrl = await fileUpload(logoImg);
      ImageType = "Image";
    } else if (selectedValue != null) {
      logoUrl.push(selectedValue?.code);
      ImageType = "Icon";
    } else {
    }

    if (valid) {
      console.log(menuIds);
      var url = "";
      const sectionDatas = [];
      let valid2 = true;

      selectedMenuDatas.forEach((menu) => {
        var matchschedule = scheduleSelections[menu.id];
        var matchingKitchen = getkitchens[menu.id];
        var DeliveryCheck = checkedState.find((x) => x.resId == menu.id);
        const menuDetails = menuIds.find((m) => m.menuId === menu.id);
        const hasOnlyDelivery = menuDetails?.menuTypeName === "Delivery";

        const sectionData = {
          id: "n",
          iconId: logoUrl[0],
          keywordName: keyword,
          sectionTypeId: sectionAdded,
          restaurantId: menu.restaurantId,
          rank: props.lastRank,
          isActive: switchCheck,
          creationId: "string",
          icon: "string",
          creationDateTime: "2023-08-07T08:15:02.698Z",
          modificationId: "string",
          modificationDate: "2023-08-07T08:15:02.698Z",
          menuId: menu.id,
          isDeleted: false,
          isArchived: false,
          scheduleId: matchschedule ? matchschedule?.id : null,
          imageType: ImageType,
          isDelivery: hasOnlyDelivery ? true : DeliveryCheck?.checked,
          isCollectionOnly: hasOnlyDelivery ? true : DeliveryCheck?.checked,
          kitchenId: matchingKitchen ? matchingKitchen.id : "0",
        };
        sectionDatas.push(sectionData);
      });

      console.log(sectionDatas);

      if (valid2) {
        var url = apiAddress + "/api/Section/postsection";
        SetloadingModal(true);
        try {
          const response = await axios.post(url, sectionDatas);
          console.log(response.data);

          toast.success("successfully submitted", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          props.onHandleSelectedData(selectedData);
          props.onHandleAddItem(false);
          setKeyword(null);
          setSelectedValue(null);
          props.loaddataonfly();
        } catch (error) {
          console.error("Error saving section:", error);
          toast.error("Failed to save section", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        } finally {
          SetloadingModal(false);
          setopenConfirmaitonModal(false);
        }
      }
    }
  };

  const handleClose = () => {
    //props.onHandleAddItem(false);
    setopenSectionCloseConfirmaitonModal(true);
  };

  const handleAddDialogClose = () => {
    props.onHandleAddItem(false);
    setopenSectionCloseConfirmaitonModal(false);
  };

  const sectionType = [
    { id: 1, title: "Shop" },
    { id: 2, title: "Standard" },
    { id: 3, title: "Special" },
    { id: 4, title: "Set menu" },
  ];

  const [sectionAdded, setsectionAdded] = useState([]);
  const sectionAddedvalue = (props) => {
    setsectionAdded(props);
    setsectionAddedValid(false);
  };

  const [menuData, setMenuData] = useState([]);
  const [allMenuData, setAllMenuData] = useState([]);

  const loadMenuData = async (props) => {
    var list = [];
    var Alllist = [];

    props.map(async (d, i) => {
      const response = await axios.get(apiAddress + "/api/Menu/" + d.id);
      console.log(d.id);
      response.data.map((dt, i) => {
        var obj = {
          id: dt.menuId,
          title: dt.menuName,
          img: dt.logoUrl,
          restaurantName: dt.restaurantName,
          restaurantId: d.id,
          isRestaurantCollectionOnly: dt.isRestaurantCollectionOnly,
        };
        list.push(obj);
        // console.log("debug-list: ", list);
        dt.MenuRestaurantMapperLists = [];
        Alllist.push(dt);
      });
      // Alllist = response.data;
    });
    setAllMenuData(Alllist);
    console.log(list);
    setMenuData(list);

    console.log("debug-allmenudata: ", allMenuData);
  };
  const [selectedMenuId, setSelectedMenuId] = useState();

  const addmenu = (data) => {
    console.log(data);
    // menuData.map((dt, i) => {
    //   if (dt.title == data) {
    //     setSelectedMenuId(dt.id);
    //   }
    // });
  };
  console.log(selectedMenuId);
  const [menuId, setMenuId] = useState();
  const subSectionMenuId = (data) => {
    props.menuList.map((dt, i) => {
      if (dt.title == data) {
        setMenuId(dt.id);
        axios
          .get(
            apiAddress + "/api/Section/getallsectionbasedonmenuid?id=" + dt.id,
          )
          .then((response) => {
            var list = [];
            response.data.map((dt, i) => {
              var obj = {
                code: dt.id,
                icon: dt.iconUrl,
                label: dt.keywordName,
              };
              list.push(obj);
            });
            // setimageMap(list)
            setsectionMap(list);
          });
      }
    });
  };
  console.log(menuId);
  const { open, onClose, dialogType } = props;

  //dialog  start
  const [openDialog, setOpenDialog] = useState(false);

  const handleAddIcon = () => {
    setOpenDialog(true);
  };

  const handleDialog = (DialogData) => {
    setOpenDialog(DialogData);
  };

  //dialog  end
  const handleImportItem = (props) => {
    // setKeyword("Burger");
    // console.log("imageMap[2]: " + imageMap[2]);
    // setSelectedValue(imageMap[2])
    // setSelectedSectionValue(imageSectionMap[5])
    setOpenImport(false);
  };
  const [switchCheck, setswitchCheck] = useState(true);
  const handleSwitchChange = () => {
    setswitchCheck(!switchCheck);
  };
  const [openImport, setOpenImport] = useState(false);
  const [openConfirmaitonModal, setopenConfirmaitonModal] = useState(false);
  const [menuIds, setMenuIds] = useState([]);
  const [menuArray, setMenuArray] = useState<string[]>([]);

  console.log(menuIds);
  const addValue = (props) => {
    // console.log("debug-dprops: ", props);
    const selectedList = [];

    props.forEach((obj) => {
      const object = allMenuData.find((x) => x.menuId === obj.id);
      if (object) {
        selectedList.push(object);
      }
    });

    setMenuIds(selectedList);
    setMainsectionErr(false);
  };

  type Menu = {
    id: string;
    title: string;
    img: string;
    restaurantId: string;
    restaurantName: string;
  };

  const handleSectionChange = (menus: Menu[]) => {
    addValue(menus);
    const menuIds = menus.map((menu) => menu.id);
    setMenuArray([...menuIds]);
  };

  const [selectedRestaurantDatas, setSelectedRestaurantDatas] = useState([]);
  const [selectedMenuDatas, setSelectedMenuDatas] = useState([]);

  const [restaurantArray, setRestaurantArray] = useState<string[]>([]);
  const [kitchens, setKitchens] = useState([]);

  console.log("selectedRestaurantDatas", selectedRestaurantDatas);
  console.log("selectedMenuDatas", selectedMenuDatas);
  console.log("restaurantArray", restaurantArray);

  const handleRemoveData = (restaurant) => {
    const updatedRestaurants = selectedRestaurantDatas.filter(
      (r) => r.id !== restaurant.id,
    );
    setSelectedRestaurantDatas(updatedRestaurants);

    // Remove associated menus
    const updatedMenus = selectedMenuDatas.filter(
      (menu) => menu.restaurantId !== restaurant.id,
    );

    setSelectedMenuDatas(updatedMenus);
    addValue(updatedMenus);
    setRestaurantArray(
      updatedRestaurants.map((updateRestaurant) => updateRestaurant.id),
    );
    setMenuArray(updatedMenus.map((updateMenus) => updateMenus.id));
  };

  type Restaurant = {
    id: string;
    title: string;
  };

  const handleRestaurantChange = (restaurant: Restaurant) => {
    const updatedArray = [...restaurantArray, restaurant.id];
    setRestaurantArray(updatedArray);
  };

  useEffect(() => {
    const getKitchenData = async () => {
      try {
        if (restaurantArray.length > 0 && menuArray.length > 0) {
          console.log("changed from kitcens 2: ", restaurantArray, menuArray);
          const response = await axios.post(
            `${apiAddress}/api/Menu/GetResturentMenuKitchenAsync`,
            {
              restaurantIds: restaurantArray,
              menuIds: menuArray,
            },
          );
          setKitchens(response.data);
        }
      } catch (error) {
        console.log(error);
      }
    };

    getKitchenData();

    if (restaurantArray.length <= 0 || menuArray.length <= 0) {
      setKitchens([]);
    }
  }, [restaurantArray, menuArray]);

  const [getkitchens, setgetkitchens] = useState<string[]>([]);

  const getkitchensFnc = (props) => {
    setgetkitchens(props);
    // Schedule.push(props)
  };

  useEffect(() => {
    loadMenuData(selectedRestaurantDatas);
  }, [selectedRestaurantDatas]);

  const [value, setValue] = useState<string>("1");

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  const [state, setState] = useState<ImageUploadState>({
    selectedImages: props.editKeywordData?.imgurl || [],
  });

  const [logoImg, setlogoImg] = useState([]);

  const handleDeleteImage = (index: number) => {
    const updatedImages = [...state.selectedImages];
    updatedImages.splice(index, 1);
    setState({ selectedImages: updatedImages });
  };

  const handleImageUpload = (event: ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files) {
      const imagesArray: string[] = [];
      const remainingSlots = 5 - state.selectedImages.length;
      const filesToUpload = Array.from(files).slice(0, remainingSlots);
      setlogoImg(filesToUpload);
      for (let i = 0; i < filesToUpload.length; i++) {
        const file = filesToUpload[i];
        const reader = new FileReader();
        reader.onloadend = () => {
          imagesArray.push(reader.result as string);
          if (imagesArray.length === filesToUpload.length) {
            const updatedImages = [...state.selectedImages, ...imagesArray];
            setState({ selectedImages: updatedImages });
          }
        };
        reader.readAsDataURL(file);
      }
    }
  };

  const fileUpload = async (data) => {
    console.log(data);
    var res = await uploadOneFiles(data[0]);
    return res;
  };

  const [Schedule, setSchedule] = React.useState([]);
  const getSchedule = (props) => {
    console.log(props);
    setSchedule(props);
    // Schedule.push(props)
  };

  const [ImageDisable, setImageDisable] = useState(false);
  const [IconDisable, setIconDisable] = useState(false);

  useEffect(() => {
    console.log(state.selectedImages);
    if (state.selectedImages.length >= 1) {
      setIconDisable(true);
    } else {
      setIconDisable(false);
    }
  }, [state]);

  useEffect(() => {
    if (selectedValue != null) {
      setImageDisable(true);
    } else {
      setImageDisable(false);
    }
  }, [selectedValue]);

  const [
    openMenuSchedulerSelectionDialog,
    setopenMenuSchedulerSelectionDialog,
  ] = useState(false);

  const handleMenuSchedularDialogOpen = () => {
    if (menuIds.length > 0) {
      setopenMenuSchedulerSelectionDialog(true);
    } else {
      toast.error("Please add menus to set schedule", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };
  const handleMenuSchedulerDialogClose = () => {
    setopenMenuSchedulerSelectionDialog(false);
  };
  const [scheduleSelections, setScheduleSelections] = useState({});

  const [checkedState, setCheckedState] = useState(
    selectedMenuDatas.map((restaurant) => ({
      resId: restaurant.id,
      checked: false,
    })),
  );

  // const handleCheckboxChange = (index) => {
  //   setCheckedState((prevState) =>
  //     prevState.map((state, i) =>
  //       i === index ? { ...state, checked: !state.checked } : state
  //     )
  //   );
  // };

  const handleCheckboxChange = (index) => {
    const menu = menuIds.find(
      (menu) => menu.menuId === selectedMenuDatas[index].id,
    );
    const hasOnlyDelivery = menu?.menuTypeName === "Delivery";

    setCheckedState((prevState) =>
      prevState.map((state, i) =>
        i === index ? { ...state, checked: !state.checked } : state,
      ),
    );

    // if (hasOnlyDelivery) {
    //   // If the menu type is only "Delivery", keep the switch on and prevent toggling
    //   // setCheckedState((prevState) =>
    //   //   prevState.map((state, i) =>
    //   //     i === index ? { ...state, checked: true } : state
    //   //   )
    //   // );
    // } else {
    //   // Otherwise, allow toggling
    //   setCheckedState((prevState) =>
    //     prevState.map((state, i) =>
    //       i === index ? { ...state, checked: !state.checked } : state
    //     )
    //   );
    // }
  };

  useEffect(() => {
    console.log(checkedState);
    console.log(checkedState[0]?.checked);
  }, [checkedState]);

  useEffect(() => {
    setCheckedState((prevState) => {
      const updatedState = selectedMenuDatas.map((restaurant) => {
        const existingState = prevState.find(
          (state) => state.resId === restaurant.id,
        );
        return existingState || { resId: restaurant.id, checked: false };
      });
      return updatedState;
    });
  }, [selectedMenuDatas]);

  const [CollectionOnlycheckedState, setCollectionOnlyCheckedState] = useState(
    selectedMenuDatas.map((res) => ({
      resId: res.id,
      checked: res.isRestaurantCollectionOnly ? true : false,
    })),
  );

  const handleCollectionOnlyChange = (resId) => {
    setCollectionOnlyCheckedState((prevState) =>
      prevState.map((state) =>
        state.resId === resId ? { ...state, checked: !state.checked } : state,
      ),
    );
  };

  useEffect(() => {
    setCollectionOnlyCheckedState(
      selectedMenuDatas.map((res) => ({
        resId: res.id,
        checked: res.isRestaurantCollectionOnly ? true : false,
      })),
    );
    console.log("selectedMenuDatas", selectedMenuDatas);
  }, [selectedMenuDatas]);

  useEffect(() => {
    console.log("CollectionOnlycheckedState", CollectionOnlycheckedState);
  }, [CollectionOnlycheckedState]);

  const closeLoadingModal = () => {
    SetloadingModal(false);
  };

  useEffect(() => {
    if (props.menu && menuData.length > 0) {
      const matchedMenu = menuData.find((m) => m.id === props.menu.id);

      if (matchedMenu) {
        setSelectedMenuDatas([matchedMenu]);
        handleSectionChange([matchedMenu]);
      }
    }
  }, [props.menu, menuData]);

  return (
    <div>
      <React.Fragment>
        <Dialog
          className="addSectionDialog"
          open={props.open}
          onClose={handleClose}
        >
          <LoadingView open={loadingModal} close={closeLoadingModal} />
          <SweetAlertModal
            headerText={"Are you sure?"}
            bodyText={"You want to save this?"}
            open={openConfirmaitonModal}
            onyes={() => {
              onClickSave();
            }}
            close={() => {
              setopenConfirmaitonModal(false);
            }}
          />
          <SweetAlertModal
            headerText={"Do you want to leave without saving?"}
            bodyText={"All changes made will be lost"}
            open={openSectionCloseConfirmaitonModal}
            onyes={handleAddDialogClose}
            close={() => {
              setopenSectionCloseConfirmaitonModal(false);
            }}
            id={2}
          />
          <Grid container>
            <Grid item xs={6}>
              <DialogTitle>
                <div className="d-flex" style={{ gap: "8px" }}>
                  <div>
                    <img src={itemImg} style={{ width: "1.8rem" }} alt="" />
                  </div>

                  <span style={{ color: "#2a7fd4" }}>
                    GoTaste :- {dialogType}
                  </span>
                </div>
              </DialogTitle>
              {/* {dialogType === 'sub' && <DialogTitle>Sub Section</DialogTitle>} */}
            </Grid>
            <Grid item xs={6}>
              <DialogActions>
                <Button
                  onClick={() => setopenSectionCloseConfirmaitonModal(true)}
                >
                  <img src={Cancel} alt="Close" style={{ width: "1.2rem" }} />
                </Button>
              </DialogActions>
            </Grid>
          </Grid>
          <DialogContent style={{ backgroundColor: "#f3f0f3" }}>
            <div>
              <TabContext value={value}>
                <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                  <TabList
                    onChange={handleChange}
                    aria-label="lab API tabs example"
                  >
                    <Tab label="Add Section" value="1" />
                    <Tab label="Kitchen" value="2" />
                  </TabList>
                </Box>
              </TabContext>

              <div className={`${value == "1" ? "d-block " : "d-none"} `}>
                <div
                  className="d-flex justify-content-end"
                  style={{ gap: "10px" }}
                >
                  <div
                    className="d-flex"
                    onClick={() => {
                      setOpenImport(!openImport);
                    }}
                  >
                    <img src={importImg} alt="" style={{ width: "1.5rem" }} />
                    <Typography>Import</Typography>
                  </div>
                </div>
                <SectionImport
                  open={openImport}
                  dialogType={dialogType}
                  onHandleAddItem={handleImportItem}
                  type={dialogType}
                />

                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={2}>
                    <div
                      className="d-flex"
                      style={{ paddingTop: "1rem", gap: "10px" }}
                    >
                      <Typography>Restaurant</Typography>
                    </div>
                  </Grid>
                  <Grid item xs={8}>
                    <Autocomplete
                      multiple
                      id="restaurant-dropdown"
                      options={restaurantDatas}
                      value={selectedRestaurantDatas}
                      onChange={(event, newInputValue, reason, detail) => {
                        setSelectedRestaurantDatas(newInputValue);
                        if (reason === "removeOption") {
                          handleRemoveData(detail.option);
                        } else {
                          handleRestaurantChange(detail.option);
                        }
                      }}
                      className="my-3"
                      getOptionLabel={(option) => option.title}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          placeholder="Restaurant"
                          label="Restaurant"
                        />
                      )}
                    />
                    {/* {RestaurantErr && (
                    <span style={{ color: "red" }}>This field is required</span>
                  )} */}
                  </Grid>
                </Grid>
                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={2}>
                    <Typography style={{ paddingTop: "1rem" }}>Menu</Typography>
                  </Grid>
                  <Grid item xs={8}>
                    {/* <AutoCompleteMultiSelect
                    id={88}
                    label={props.title}
                    placeholder={"Menu"}
                    value={addValue}
                    datas={menuData}
                  /> */}

                    <Autocomplete
                      multiple
                      options={menuData}
                      value={selectedMenuDatas}
                      isOptionEqualToValue={(option, value) =>
                        option.id === value.id
                      }
                      getOptionLabel={(option) =>
                        option.menuName || option.title
                      }
                      onChange={(event, newValue) => {
                        setSelectedMenuDatas(newValue);
                        handleSectionChange(newValue);
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Menu"
                          placeholder="Menu"
                        />
                      )}
                      renderOption={(props, option) => (
                        <Box
                          component="li"
                          sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                          {...props}
                        >
                          <img
                            loading="lazy"
                            src={option.img}
                            alt=""
                            style={{ width: "2rem" }}
                          />
                          <div
                            className="d-flex "
                            style={{ flexDirection: "column" }}
                          >
                            <div className="d-flex" style={{ gap: "10px" }}>
                              <h5 className="mb-0">{option.title}</h5>
                            </div>

                            <span
                              className="text-muted"
                              style={{ fontSize: "1rem", marginTop: "0" }}
                            >
                              {" "}
                              {option.restaurantName}
                            </span>
                          </div>
                        </Box>
                      )}
                    />

                    {MainsectionErr && (
                      <span style={{ color: "red" }}>
                        This field is required
                      </span>
                    )}
                  </Grid>
                  {/* <Grid
                  item
                  xs={1}
                  className="AddItemplusIcon"
                  onClick={() => setOpenMenu(true)}
                >
                  <button className="modalAddButton">+Add Main Section</button>
                  
                </Grid> */}
                </Grid>
                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={2}>
                    <Typography style={{ paddingTop: "2rem" }}>Name</Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <TextField
                      placeholder="Name"
                      value={keyword}
                      onChange={handleKeyword}
                      fullWidth
                      margin="normal"
                      InputLabelProps={{ sx: { color: "#371B17" } }}
                    />
                    <span
                      className={`${keywordValid ? "" : "d-none"}`}
                      style={{ color: "red" }}
                    >
                      {" "}
                      keyword Required
                    </span>
                  </Grid>
                </Grid>
                {dialogType === "Add Sub Section" && (
                  <Grid container sx={{ padding: "0.5rem" }}>
                    <Grid item xs={2}>
                      <Typography style={{ paddingTop: "1rem" }}>
                        Section
                      </Typography>
                    </Grid>
                    <Grid item xs={8}>
                      <Autocomplete
                        id="country-select-demo"
                        // sx={{ width: 300 }}
                        options={SectionMap}
                        value={selectedSectionValue}
                        onChange={handleAutocompleteSectionChange}
                        autoHighlight
                        getOptionLabel={(option) => option.label}
                        renderOption={(props, option) => (
                          <Box
                            component="li"
                            sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                            {...props}
                          >
                            {option.label}
                          </Box>
                        )}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Select a section"
                            inputProps={{
                              ...params.inputProps,
                              autoComplete: "new-password", // disable autocomplete and autofill
                            }}
                          />
                        )}
                        // filterOptions={filterOptions}
                      />
                      <span
                        className={`${SectionValid ? "" : "d-none"}`}
                        style={{ color: "red" }}
                      >
                        {" "}
                        Section Required
                      </span>
                    </Grid>
                  </Grid>
                )}
                {dialogType === "Add Sub Section from addItem" && (
                  <>
                    <Grid container sx={{ padding: "0.5rem" }}>
                      <Grid item xs={2}>
                        <Typography style={{ paddingTop: "1rem" }}>
                          Section
                        </Typography>
                      </Grid>
                      <Grid item xs={8}>
                        <Autocomplete
                          id="country-select-demo"
                          options={SectionMap}
                          value={selectedSectionValue}
                          onChange={handleAutocompleteSectionChange}
                          autoHighlight
                          getOptionLabel={(option) => option.label}
                          renderOption={(props, option) => (
                            <Box
                              component="li"
                              sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                              {...props}
                            >
                              {option.label}
                            </Box>
                          )}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Select a section"
                              inputProps={{
                                ...params.inputProps,
                                autoComplete: "new-password", // disable autocomplete and autofill
                              }}
                            />
                          )}
                        />
                        <span
                          className={`${SectionValid ? "" : "d-none"}`}
                          style={{ color: "red" }}
                        >
                          {" "}
                          Section Required
                        </span>
                      </Grid>
                    </Grid>
                  </>
                )}
                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={2}>
                    <Typography style={{ paddingTop: "1rem" }}>
                      Image
                    </Typography>
                  </Grid>
                  <Grid xs={2} style={{ paddingTop: "0.5rem" }}>
                    <Button
                      variant="contained"
                      component="label"
                      //   color="primary"
                      className="uploadButton"
                      // style={{ backgroundColor: 'white', color: 'gray' }}
                    >
                      <img
                        src={galleryIcon}
                        alt="photo"
                        // style={{ width: '2rem' }}
                      />
                      Upload
                      <input
                        hidden
                        accept="image/*"
                        multiple
                        type="file"
                        onChange={handleImageUpload}
                        disabled={
                          state.selectedImages.length >= 1 || ImageDisable
                        }
                      />
                    </Button>
                  </Grid>
                  <Grid item xs={1}>
                    <Typography style={{ paddingTop: "1rem" }}>
                      --Or--
                    </Typography>
                  </Grid>
                  <Grid item xs={1}>
                    <Typography style={{ paddingTop: "1rem" }}>Icon</Typography>
                  </Grid>
                  <Grid item xs={4}>
                    <Autocomplete
                      id="country-select-demo"
                      // sx={{ width: 300 }}
                      disabled={IconDisable}
                      options={imageMap}
                      value={selectedValue}
                      onChange={handleAutocompleteChange}
                      autoHighlight
                      getOptionLabel={(option) => option.label}
                      renderOption={(props, option) => (
                        <Box
                          component="li"
                          sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                          {...props}
                        >
                          <img
                            src={option.icon}
                            alt=""
                            style={{ width: "2rem" }}
                          />

                          {option.label}
                        </Box>
                      )}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Select a icon"
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: "new-password", // disable autocomplete and autofill
                          }}
                        />
                      )}
                    />
                    <span
                      className={`${selectedValueValid ? "" : "d-none"}`}
                      style={{ color: "red" }}
                    >
                      {" "}
                      Icon Required
                    </span>
                  </Grid>
                  {/* image show start */}
                  <Grid container sx={{ padding: "0.5rem" }}>
                    <Grid item xs={2}></Grid>
                    <Grid item xs={9}>
                      <Grid container spacing={2}>
                        {state.selectedImages
                          ? state.selectedImages.map((image, index) => (
                              <Grid item xs={2} sm={2} md={2} key={index}>
                                {/* <Paper> */}
                                <div
                                  style={{
                                    position: "relative",
                                    paddingTop: "20px",
                                  }}
                                >
                                  <img
                                    src={image}
                                    alt={`Preview ${index + 1}`}
                                    style={{
                                      maxWidth: "100%",
                                      maxHeight: "100%",
                                      objectFit: "cover",
                                    }}
                                  />
                                  <IconButton
                                    style={{
                                      position: "absolute",
                                      top: "-6px",
                                      right: "-23px",
                                      color: "gray",
                                    }}
                                    onClick={() => handleDeleteImage(index)}
                                  >
                                    <CancelIcon />
                                  </IconButton>
                                </div>
                                {/* </Paper> */}
                              </Grid>
                            ))
                          : ""}
                      </Grid>
                    </Grid>
                  </Grid>
                  {/* image show end */}
                </Grid>

                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={2}>
                    <Typography style={{ paddingTop: "1rem" }}>
                      Section Type
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <AutoCompleteMultiSelect
                      id={1}
                      placeholder={"Section Type"}
                      datas={sectionType}
                      value={sectionAddedvalue}
                    />
                    <span
                      className={`${sectionAddedValid ? "" : "d-none"}`}
                      style={{ color: "red" }}
                    >
                      {" "}
                      Section Type Required
                    </span>
                  </Grid>
                </Grid>
                {/* <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={12}>
                  <SchedulerComponent
                      from="discount"
                      getSchedule={getSchedule}
                      showSchedulerTable={true}
                    />
                  </Grid>
                </Grid> */}
                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={2}>
                    <Typography>Scheduler</Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <button
                      className="modalAddButton"
                      onClick={handleMenuSchedularDialogOpen}
                    >
                      Select Scheduler
                    </button>
                  </Grid>
                </Grid>
                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={2}>
                    <Typography>Is Active?</Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <Switch
                      checked={switchCheck}
                      onChange={handleSwitchChange}
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  </Grid>
                </Grid>

                <Grid container spacing={2} sx={{ padding: "0.5rem" }}>
                  <Grid
                    item
                    xs={2}
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    <Typography>Delivery:</Typography>
                  </Grid>
                  <Grid item xs={9}>
                    <Grid container>
                      {selectedMenuDatas.map((restaurant, index) => {
                        const menu = menuIds.find(
                          (menu) => menu.menuId === restaurant.id,
                        );

                        // console.log("debug123m: ", menu);

                        const hasOnlyDelivery =
                          menu?.menuTypeName === "Delivery";

                        const hasDelivery =
                          menu?.menuTypeName?.includes("Delivery");

                        const collectionToggleState =
                          CollectionOnlycheckedState.find(
                            (state) => state.resId === restaurant.id,
                          );

                        const hasOnlyCollection = menu?.isCollectionOnly;

                        return (
                          <Grid
                            item
                            xs={6}
                            key={restaurant.id}
                            sx={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 0.5,
                              alignItems: "left",
                            }}
                          >
                            <Grid
                              sx={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                              }}
                            >
                              <Grid item xs={8}>
                                <Typography sx={{ marginRight: "0.5rem" }}>
                                  {restaurant.title}
                                </Typography>
                              </Grid>

                              <Grid item xs={4}>
                                <Tooltip
                                  title={
                                    hasDelivery
                                      ? ""
                                      : "The Menu type is not Delivery"
                                  }
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Switch
                                      checked={
                                        hasOnlyDelivery ||
                                        checkedState[index]?.checked
                                      }
                                      onChange={() =>
                                        handleCheckboxChange(index)
                                      }
                                      inputProps={{
                                        "aria-label": restaurant.title,
                                      }}
                                      size="small"
                                      disabled={hasOnlyDelivery || !hasDelivery}
                                    />
                                    {!hasDelivery && (
                                      <InfoOutlinedIcon
                                        color="action"
                                        sx={{ marginLeft: 1 }}
                                      />
                                    )}
                                  </div>
                                </Tooltip>
                              </Grid>
                            </Grid>
                            {(checkedState[index]?.checked ||
                              hasOnlyCollection) && (
                              <div>
                                {true && (
                                  <Grid
                                    sx={{
                                      display: "flex",
                                      flexDirection: "row",
                                      alignItems: "center",
                                      marginLeft: "2rem",
                                    }}
                                  >
                                    <Grid item xs={8}>
                                      <Typography
                                        sx={{ marginRight: "0.5rem" }}
                                      >
                                        Collection only
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={4}>
                                      {/* <Tooltip
                                        title={
                                          restaurant?.isRestaurantCollectionOnly
                                            ? "Restaurant is collection only."
                                            : "Restaurant is not collection only."
                                        }
                                        arrow
                                      > */}
                                      <span>
                                        <Switch
                                          checked={
                                            hasOnlyCollection ||
                                            collectionToggleState?.checked ||
                                            false
                                          }
                                          // onChange={() => {
                                          //   if (!restaurant?.isRestaurantCollectionOnly) {
                                          //     handleCollectionOnlyChange(restaurant.id);
                                          //   }
                                          // }}
                                          onChange={() => {
                                            handleCollectionOnlyChange(
                                              restaurant.id,
                                            );
                                          }}
                                          size="small"
                                          disabled={hasOnlyCollection}
                                          //disabled={restaurant?.isRestaurantCollectionOnly}
                                        />
                                      </span>
                                      {/* </Tooltip> */}
                                    </Grid>
                                  </Grid>
                                )}
                              </div>
                            )}
                            {/* {hasOnlyDelivery && (
                              <div>
                                {true && (
                                  <Grid sx={{ display: "flex", flexDirection: "row", alignItems: "center", marginLeft: "2rem" }}>
                                    <Grid item xs={8}>
                                      <Typography sx={{ marginRight: "0.5rem" }}>
                                        Collection only
                                      </Typography>
                                    </Grid>
                                    <Grid item xs={4}>
                                      <Tooltip
                                        title={
                                          restaurant?.isRestaurantCollectionOnly
                                            ? "Restaurant is collection only."
                                            : "Restaurant is not collection only."
                                        }
                                        arrow
                                      >
                                        <span>
                                          <Switch
                                            checked={restaurant?.isRestaurantCollectionOnly ? true : collectionToggleState?.checked || false}
                                            onChange={() => {
                                              if (!restaurant?.isRestaurantCollectionOnly) {
                                                handleCollectionOnlyChange(restaurant.id);
                                              }
                                            }}
                                            size="small"
                                            disabled={restaurant?.isRestaurantCollectionOnly}
                                          />
                                        </span>
                                      </Tooltip>

                                    </Grid>
                                  </Grid>
                                )}
                              </div>
                            )} */}
                          </Grid>
                        );
                      })}
                    </Grid>
                  </Grid>
                </Grid>

                <Grid container sx={{ padding: "0.5rem" }}>
                  <Grid item xs={12}>
                    <div className="d-flex justify-content-end">
                      <Button
                        onClick={() => {
                          setopenConfirmaitonModal(true);
                        }}
                      >
                        Save
                      </Button>
                    </div>
                  </Grid>
                </Grid>
              </div>

              <div className={`${value == "2" ? "d-block " : "d-none"} `}>
                <MenuKitchen kitchens={kitchens} getKitchens={getkitchensFnc} />
              </div>
              <Grid item xs={1}></Grid>
              {/* <Grid container sx={{ padding: '0.5rem' }}>
                <Grid item xs={2}></Grid>
                <Grid item xs={9}>
                  {dialogType === 'Add Sub Section' && <SectionTableSubSection selectedValue={selectedData} selectedSectionValue={selectedData} />}
                </Grid>
              </Grid> */}
            </div>
          </DialogContent>
        </Dialog>
      </React.Fragment>
      <CustomDialog
        open={openDialog}
        dialogTitle={"Add Icon"}
        onClose={handleDialog}
      />

      {openMenuSchedulerSelectionDialog && (
        <MenuSchedulerSelectDialog
          open={openMenuSchedulerSelectionDialog}
          restaurantSelected={selectedMenuDatas}
          //onHandleAddItem={handleAddItem}
          onClose={handleMenuSchedulerDialogClose}
          //onToggleSwitch={handleSwitchToggle}
          onSave={(data) => setScheduleSelections(data)}
          prevScheduleSelecection={scheduleSelections}
        />
      )}
    </div>
  );
}

export default AddSectionDialog;
